<template>
  <div v-loading="!complete">
<!--     <div class="h-60 bg-wh pos-rel bor-b-ccc top-title">
      <el-button style="position: absolute;top:12px;right:10px" type="primary" @click="add()" :loading="isLoading">提交</el-button>
      <el-button style="position: absolute;top:12px;left:0px" @click="goback()">返回</el-button>
    </div> -->
    <div>
      <commonFormRender
        ref="form"
        :form="form"
        :formField="nodeField"
        :modelId="modelId"
        :isReadonly="isReadonly"
        :complete="complete"
        @uploading="uploading">
        <div class="m-t-20">
          <el-button type="primary" @click="add()" :loading="isLoading">提交</el-button>
          <el-button @click="goback()" class='flowForm'>返回</el-button>
        </div>
      </commonFormRender>
    </div>
    <flow-process-dialog
      ref="flowProcessControl"
      v-if="currentData.currentType !== UESR_CONSTANT"
      :currentData="currentData"
      @handleDialogResult="handleDialogResult">
    </flow-process-dialog>
  </div>
</template>

<style scoped>
.top-title {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%
}
</style>

<script>
  import http from '../../../assets/js/http'
  import modelConfig from '../../../config/modelConfig'
  import commonFormRender from '../../Common/business/render/commonFormRender'
  import flowProcessDialog from './flowProcessDialog.vue'

  export default {
    data() {
      return {
        flowId: '',
        caseId: '',
        modelId: -1,
        caseNodeId: '',
        editors: [],
        isLoading: false,
        nodeField: [],
        isUploading: false,
        form: {},
        host: '',
        fileType: [
          { id: 10, name: '图片' },
          { id: 20, name: '压缩文件' },
          { id: 30, name: 'word文档' },
          { id: 40, name: 'excel表格' },
          { id: 50, name: 'ppt幻灯片' },
          { id: 60, name: 'PDF' }
        ],
        complete: false,
        nodeType: null, // 节点类型
        examineStatus: 10, // 审批状态
        connectType: null, // 连接状态
        nextIden: null, // 流向节点
        nextNode: [], // 流向节点选择数组
        keyData: {},
        currentData: {
          currentType: 10, // 当前选择类型
          currentContent: [] // 当前数组
        }
      }
    },
    components: {
      commonFormRender,
      flowProcessDialog
    },
    created() {
      this.isLoading = true
      this.flowId = this.$route.params.id
      // this.caseId = this.$route.query.case_id
      // this.caseNodeId = this.$route.query.case_node_id
      this.host = HOST
      this.getCaseDetail()
    },
    methods: {
      isReadonly(item) {
        return item.default.field_auth == 10
      },
      uploading(isUploading) {
        this.isUploading = isUploading
      },
      getCaseDetail() {
        this.apiGet(`bpm/flows/${this.flowId}/start`).then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            this.nodeField = res.data.nodeField
            this.form = res.data.formData
            this.modelId = res.data.modelId
            this.complete = true
            // 获取分组 / 部门数据
            this.nextNodeConfig = res.data.nextNodeConfig
            if (this.nextNodeConfig && this.nextNodeConfig.flag !== 10) {
              let type = this.nextNodeConfig.flag
              this.currentData.currentType = type
              if (type === this.USER_GROUP) {
                this.nextNodeConfig.groups = this.handleDefaultSelected(this.nextNodeConfig.group)
                this.currentData.currentContent = this.nextNodeConfig.groups
              } else if (type === this.USER_DEPARTMENT) {
                this.nextNodeConfig.departments = this.handleDefaultSelected(this.nextNodeConfig.departments)
                this.currentData.currentContent = this.nextNodeConfig.departments
              }
            }
          } else {
            setTimeout(() => {
              this.goback()
            }, 1000)
            _g.dealError(this, res)
          }
        })
      },
      handleDefaultSelected(arr) { // 给每个数据加上selected
        if (arr && arr.length > 0) {
          _(arr).forEach((res, index) => {
            res.selected = false
            if (res.list && res.list.length > 0) {
              _(res.list).forEach((childRes, childIndex) => {
                childRes.selected = false
              })
            }
          })
        }
        return arr
      },
      handleDialogResult(data, postData) {
        postData = this.extractCurrentData(data, postData)
        this.post(postData)
      },
      add() {
        if (this.isUploading) {
          _g.toastMsg(this, 'warning', '文件正在上传，稍后再点击提交')
        } else {
          this.submitData()
        }
      },
      submitData() {
        let postData = _.cloneDeep(this.form)
        // console.log('postData = ', postData)
        // return
        if (this.nodeType == 30) {
          // 节点类型为审批网关，设置通过状态
          postData.examine_status = this.examineStatus
        }
        if (JSON.stringify(this.rules) != '{}') {
          this.$refs.form.validate((pass) => {
            if (pass) {
              this.handleSubmitData(postData)
            } else {
              _g.toastMsgForForm(this)
            }
          })
        } else {
          this.handleSubmitData(postData)
        }
      },
      handleSubmitData(postData) {
        let self = this
        let type = this.currentData.currentType
        let content = this.currentData.currentContent
        if (type !== this.UESR_CONSTANT && content && content.length > 0) {
          if (content.length === 1) {
            // 只有一个用户组，用户组的数据小于等于一个
            if (content[0].list && content[0].list.length <= 1) {
              let arr = []
              if (content[0].list.length === 1) {
                arr.push(content[0].list[0].id)
              }
              postData = this.extractCurrentData(arr, postData)
              this.post(postData)
              return
            }
          }
          setTimeout(() => {
            self.$refs.flowProcessControl.openDialog(postData)
          })
        } else {
          this.post(postData)
        }
      },
      extractCurrentData(arr, postData) {
        postData.receivers = arr
        return postData
      },
      post(postData) {
        postData.flag = this.currentData.currentType
        this.isLoading = !this.isLoading
        this.apiPost(`bpm/flows/${this.flowId}/startFlow`, postData).then((res) => {
          this.isLoading = !this.isLoading
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '提交成功')
            setTimeout(() => {
              this.goback()
            }, 1500)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      goback() {
        router.go(-1)
      }
    },
    mixins: [http, modelConfig]
  }
</script>



// WEBPACK FOOTER //
// form.vue?e478f9ec